import React from 'react';

const DisbursedDate = ({ row, field }) => {
	return <>{row.lead_type == 1 ? '' : row?.disbursed_date}</>;
};

export default DisbursedDate;
